<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel flush">
				<div class="heading">User Access Log for {{asset.asset_name}}</div>
				<div class="content">
					<div *ngIf="pageLogs === undefined" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading user access logs...
					</div>
					<div *ngIf="pageLogs && pageLogs.length === 0" class="pt-3 pb-3">
						No user access logs available
					</div>
					<ng-container *ngIf="pageLogs && pageLogs.length > 0">
						<table class="table-user-access">
							<thead>
								<tr>
									<th>Access Time</th>
									<th>User</th>
								</tr>
							</thead>
							<tbody *ngFor="let log of pageLogs">
								<tr>
									<td>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</td>
									<td>{{log.email}}</td>
								</tr>
							</tbody>
						</table>
						<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
							[rotate]="true"></ngb-pagination>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>